module.exports = __webpack_public_path__ + "img/addcp.30529bc6.png";